var map = {
	"./bio_img-v2.jpg": 9012,
	"./cd-image.png": 6042,
	"./down-arrow.png": 5979,
	"./fb.png": 6627,
	"./gallery/balcony.jpg": 1556,
	"./gallery/img-black.jpg": 6367,
	"./gallery/piano-artsy.jpg": 9951,
	"./gallery/piano-closeup.jpg": 3995,
	"./gallery/piano-landscape.jpg": 8071,
	"./gallery/piano.jpg": 4107,
	"./gallery/portrait-2.jpg": 2566,
	"./gallery/portrait.jpg": 4127,
	"./gallery/stairs.jpg": 2476,
	"./gmail.png": 417,
	"./insta.png": 2346,
	"./linkedin.png": 5405,
	"./main_pic1.jpg": 8312,
	"./spotify.png": 9237,
	"./wall-bg-v2.png": 3846,
	"./yt-icon.png": 6384
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;